export default __webpack_public_path__ + "static/Pablo_Fede_SMALL-2de4a4000e60d9031cacc29b7792548d.jpg";